/**
 * Copyright (c) 2026 Répét Contributors
 * Licensed under the MIT License
 * See LICENSE file in the project root for full license text
 */

/**
 * Génère un identifiant UUID v4
 */
export function generateId(): string {
  return crypto.randomUUID()
}
